<template>
  <div class="ak-nav-contnet">
    <div class="ak-nav-contnet-nav">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-vertical-demo"
        mode="vertical"
        @select="handleSelect"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#fff"
      >
        <el-menu-item index="9">
          <label class="el-icon-my-Dashboard_icon nav-icon"></label
          ><label class="nav-icon">Dashboard</label></el-menu-item
        >

        <el-submenu index="99">
          <template slot="title">
            <label class="el-icon-my-Dashboard_icon nav-icon"></label
            ><label class="nav-icon">Marketing Materials</label>
          </template>
          <el-menu-item index="99-2">All Files</el-menu-item>
          <el-menu-item index="99-1">Search Files</el-menu-item>
          <el-menu-item index="99-3">Search History</el-menu-item>
        </el-submenu>

        <!-- <el-menu-item index="4">
			<label class="el-icon-my-News_icon1 nav-icon"></label><label class="nav-icon">News</label></el-menu-item>
			-->

      <!-- Deepsearch 系统嵌入替代原有Marketing Materials -->
        <!-- <el-submenu index="8"> -->
          <!-- <template slot="title"> -->
            <!-- <label class="el-icon-my-MarketingMaterials_icon1 nav-icon"></label ><label class="nav-icon">Marketing Materials</label></template> -->
          <!-- <el-menu-item index="8-1">About Akuvox</el-menu-item> -->
          <!-- <el-menu-item index="8-2">Products</el-menu-item> -->
          <!-- <el-menu-item index="8-3">Solutions</el-menu-item> -->
          <!-- <el-menu-item index="8-4">Exhibitions</el-menu-item> -->
        <!-- </el-submenu> -->

        <el-submenu index="6">
          <template slot="title">
            <label class="el-icon-my-ProductMaterials_icon nav-icon"></label
            ><label class="nav-icon">Product Materials</label></template
          >
          <el-menu-item index="6-1">Product Documents</el-menu-item>
          <el-menu-item index="6-2">Technology Partners</el-menu-item>
        </el-submenu>

        <el-menu-item index="5">
          <label class="el-icon-my-ProjectRegistration_icon nav-icon"></label
          ><label class="nav-icon">Project Registration</label></el-menu-item
        >

        <el-menu-item index="3">
          <label class="el-icon-my-SaleLeads_icon1 nav-icon"></label
          ><label class="nav-icon">Sale Leads</label></el-menu-item
        >

        <el-menu-item
          v-if="this.openOrder == '0' || this.openOrder == 'null'"
          index="7"
        >
          <label class="el-icon-my-Ordering_icon nav-icon"></label
          ><label class="nav-icon">Ordering</label></el-menu-item
        >

        <el-menu-item @click="learning" index="10">
          <label class="el-icon-my-Learning_icon1 nav-icon"></label
          ><label class="nav-icon">E-learning</label></el-menu-item
        >

        <el-menu-item @click="akuvox" index="13">
          <label class="el-icon-link"></label
          ><label class="nav-icon">Akuvox Wiki</label></el-menu-item
        >

        <el-menu-item @click="techSupport" index="11">
          <label class="el-icon-my-TechSupport_icon1 nav-icon"></label
          ><label class="nav-icon">Tech Support</label></el-menu-item
        >

        <el-menu-item index="12">
          <label class="el-icon-my-Legal_icon nav-icon"></label
          ><label class="nav-icon">Legal</label></el-menu-item
        >

        <el-menu-item
          v-if="
            this.grade == '4' ||
            this.type == '0' ||
            this.type == '1' ||
            this.type == '2'
          "
          index="2"
        >
          <label class="el-icon-my-Partners_icon1 nav-icon"></label
          ><label class="nav-icon">Partners</label></el-menu-item
        >

        <el-submenu
          v-if="this.type == '0' || this.type == '1' || this.type == '2'"
          index="1"
        >
          <template slot="title">
            <label class="el-icon-my-Management_icon nav-icon"></label
            ><label class="nav-icon">Management</label></template
          >
          <el-menu-item v-if="this.type == '1' || this.type == '2'" index="1-1"
            >Account</el-menu-item
          >
          <el-menu-item
            v-if="this.type == '0' || this.type == '1' || this.type == '2'"
            index="1-2"
            >Partner</el-menu-item
          >
          <!-- <el-menu-item index="1-3">Product Number</el-menu-item> -->
          <!-- <el-menu-item v-if="this.type == '1' || this.type == '2'" index="1-4">Product Material</el-menu-item> -->
          <!-- <el-menu-item v-if="this.type == '1' || this.type == '2'" index="1-5">Marketing Material</el-menu-item> -->

          <el-submenu v-if="this.type == '1' || this.type == '2'" index="1-4">
            <template slot="title">
              <label class="nav-icon">Product Material</label></template>
            <el-menu-item index="1-4-1">Product Documents</el-menu-item>
            <el-menu-item index="1-4-2">Technology Partners</el-menu-item>
          </el-submenu>

          <el-submenu v-if="this.type == '1' || this.type == '2'" index="1-5">
            <template slot="title">
              <label class="nav-icon">Marketing Material</label></template
            >
            <el-menu-item index="1-5-1">About Akuvox</el-menu-item>
            <el-menu-item index="1-5-2">Products</el-menu-item>
            <el-menu-item index="1-5-3">Solutions</el-menu-item>
            <el-menu-item index="1-5-4">Exhibitions</el-menu-item>
          </el-submenu>

           <!-- 超级管理员添加产品后台管理 -->
          <el-submenu v-if="this.type == '2'" index="14">
            <template slot="title">
              <label class="nav-icon">Marketing分类编辑</label></template
            >
            <el-menu-item index="14-1">Product Category</el-menu-item>
            <el-menu-item index="14-2">Product Model</el-menu-item>
            <el-menu-item index="14-3">Document Type</el-menu-item>
          </el-submenu>

          <!-- 超级管理员添加Product Document后台管理 -->
           <el-submenu v-if="this.type == '2'" index="15">
            <template slot="title">
              <label class="nav-icon">产品文档分类编辑</label></template
            >
            <el-menu-item index="15-1">Product Category</el-menu-item>
            <el-menu-item index="15-2">Product Model</el-menu-item>
            <el-menu-item index="15-3">Document Type</el-menu-item>
          </el-submenu>
          <!-- <el-menu-item v-if="this.type == '1' || this.type == '2'" index="1-6">News</el-menu-item> -->
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>
<script>
import "@/assets/icon/iconfont.css";
export default {
    components: {},
    data() {
        return {
            index2Router: {
                "1-1": "/account",
                "1-2": "/partner",
                "1-3": "/productNumber",
                "1-4-1": "/certification",
                "1-4-2": "/technologyPartner",
                "1-5-1": "/company",
                "1-5-2": "/product",
                "1-5-3": "/solution",
                "1-5-4": "/exhibition",
                "1-6": "/newsPublish",
                2: "/partners",
                3: "/saleLeads",
                4: "/news",
                5: "/projectRegistration",
                "6-1": "/certifications",
                "6-2": "/technologyPartners",
                7: "/ordering",
                "8-1": "/companys",
                "8-2": "/products",
                "8-3": "/solutions",
                "8-4": "/exhibitions",
                9: "/dashboard",
                99: "/deepsearch",
                "99-1": "/deepsearchSearch",
                "99-2": "/deepsearchFiles",
                "99-3": "/deepsearchHistory",
                12: "/legal",
                "14-1":"/productCategory",
                "14-2":"/productModel",
                "14-3":"/documentType",

                "15-1":"/documentsProductCategory",
                "15-2":"/documentsProductModel",
                "15-3":"/documentsDocumentType"
            },
            router2Index: {
                account: "1-1",
                partner: "1-2",
                productNumber: "1-3",
                certification: "1-4-1",
                technologyPartner: "1-4-2",
                company: "1-5-1",
                product: "1-5-2",
                solution: "1-5-3",
                exhibition: "1-5-4",
                newsPublish: "1-6",
                partners: "2",
                saleLeads: "3",
                news: "4",
                projectRegistration: "5",
                certifications: "6-1",
                technologyPartners: "6-2",
                ordering: "7",
                companys: "8-1",
                products: "8-2",
                solutions: "8-3",
                exhibitions: "8-4",
                dashboard: "9",
                deepsearch: "99",
                deepsearchSearch: "99-1",
                deepsearchFiles: "99-2",
                deepsearchHistory: "99-3",
                learning: "10",
                techSupport: "11",
                legal: "12",
                akuvox: "13",
                productCategory:"14-1",
                productModel:"14-2",
                documentType:"14-3",
                documentsProductCategory:"15-1",
                documentsProductModel:"15-2",
                documentsDocumentType:"15-3"
            },
            userData: {},
            type: "",
            grade: "",
            openOrder: ""
        };
    },
    mounted() {
        this.type = localStorage.getItem("type");
        this.grade = localStorage.getItem("grade");
        this.openOrder = localStorage.getItem("openOrder");
    },
    methods: {
        handleSelect(key) {
            if (key in this.index2Router) this.$router.push(this.index2Router[key]);
        },
        learning() {
            this.$http.get(
                "checkBindOtherSys",
                {
                    Type: "learning"
                },
                (data) => {
                    let status = data.data.Status;
                    if (status === 0) {
                        this.$baseNotice.messageBox(
                            "confirm",
                            "You have not bound the learning system account, whether to go to the binding.",
                            "Tips",
                            "info"
                        )(() => {
                            this.$router.push("learn");
                        });
                    } else {
                        this.$http.post(
                            "loginOtherSys",
                            {
                                Type: "learning"
                            },
                            (data) => {
                                let tempwindow = window.open();
                                tempwindow.location = data.url;
                            }
                        );
                    }
                }
            );
        },
        techSupport() {
            window.open("http://Ticket.akuvox.com/");
        },
        akuvox() {
            window.open("http://wiki.akuvox.com");
        },
        getUserInfo() {
            this.$http.get("getAccountInfo", {}, (data) => {
                this.userData = data.data;
            });
        }
    },
    computed: {
        activeIndex() {
            return this.router2Index[this.$route.matched[1].name];
        }
    }
};
</script>
<style lang="less">
@navBgColor: #545c64;
.ak-nav-contnet {
  background-color: @navBgColor;
  min-width: 250px;
  overflow: auto;
  height: 100%;
  .ak-nav-contnet-nav {
    width: 250px;
    background-color: @navBgColor;
  }

  .ak-nav-content-icon {
    width: 60px;
    height: 60px;
    outline: none;
    overflow: hidden;
    margin-right: 10px;
    border-radius: 50%;
    img {
      max-height: 60px;
    }
  }
}
.personalData {
  width: 100%;
  box-sizing: border-box;
  ul.Data {
    padding-bottom: 10px;
    border-bottom: 1px gainsboro dashed;
    li {
      font-size: 14px;
      line-height: 30px;
      height: 30px;
      padding-left: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      label {
        color: gray;
        font-size: 14px;
        width: 55px;
        display: inline-block;
      }
    }
  }
}

ul.modify {
  width: calc(~"100% + 20px");
  list-style: none;
  margin-left: -10px;
  li {
    font-size: 0.9rem;
    line-height: 40px;
    height: 40px;
    color: gray;
    cursor: pointer;
    padding-left: 20px;
    font-weight: bold;
  }
  li:hover {
    background-color: rgb(60, 160, 220);
    color: white;
  }
}
.nav-icon {
  vertical-align: middle;
}
.ak-nav-content-data {
  cursor: pointer;
  font-family: "仿宋体";
  width: 150px;
  color: white;
  text-align: left;
  line-height: 60px;
  p {
    line-height: 20px;
  }
}
</style>
